import { useNavigate } from 'react-router-dom';

const DISMISSED_KEY_PREFIX = 'patient_profile_onboarding_dismissed';

export const getPatientProfileOnboardingDismissedKey = (patientId) =>
    patientId ? `${DISMISSED_KEY_PREFIX}_${patientId}` : DISMISSED_KEY_PREFIX;

const PatientProfileOnboardingModal = ({ onClose, patientId }) => {
    const navigate = useNavigate();

    const handleGoToProfile = () => {
        if (patientId) {
            sessionStorage.setItem(getPatientProfileOnboardingDismissedKey(patientId), '1');
        }
        onClose();
        navigate('/patient/perfil');
    };

    const handleDismiss = () => {
        if (patientId) {
            sessionStorage.setItem(getPatientProfileOnboardingDismissedKey(patientId), '1');
        }
        onClose();
    };

    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div
                className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-amber-200 p-8 text-center"
                role="dialog"
                aria-modal="true"
                aria-labelledby="patient-profile-onboarding-title"
            >
                <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-amber-100 flex items-center justify-center">
                    <svg className="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                </div>
                <h2 id="patient-profile-onboarding-title" className="text-xl font-bold text-gray-800 mb-2">
                    Completa tu perfil
                </h2>
                <p className="text-gray-600 text-sm mb-4 text-left">
                    Para usar Redplika y agendar teleconsultas necesitas completar tu <strong>perfil de usuario</strong> con tus datos básicos.
                </p>
                <ol className="text-left text-sm text-gray-600 space-y-2 mb-6 list-decimal list-inside">
                    <li>Ve a la sección <strong>Perfil</strong> en el menú</li>
                    <li>Completa tus datos personales y de contacto</li>
                    <li>Guarda los cambios para continuar</li>
                </ol>
                <button
                    type="button"
                    onClick={handleGoToProfile}
                    className="w-full py-3 px-4 bg-[#1f94c2] hover:bg-[#1a7ba8] text-white font-semibold rounded-xl transition-colors"
                >
                    Ir a completar mi perfil
                </button>
                <button
                    type="button"
                    onClick={handleDismiss}
                    className="mt-3 w-full py-2 px-4 text-gray-600 hover:text-gray-800 text-sm font-medium"
                >
                    Recordármelo después
                </button>
            </div>
        </div>
    );
};

export default PatientProfileOnboardingModal;
